export default __webpack_public_path__ + "static/media/doorSfx.c284a012.mp3";